import {
  Box, Button, FileInput, Form, SidebarModal,
} from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@domain-group/javascript-utils'

import useBulkRemapCampaignPortalsModal from './hooks/useBulkRemapCampaignPortalsModal'

type ModalCallbacks = {
  bulkPortalRemap: (bulkRemapPayload: HandleCallbackActionParams) => void,
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  modalKey?: string,
  showModal: boolean,
}

const BulkRemapCampaignPortalsModal = (props: ModalProps) => {
  const { callbacks, modalKey = 'BulkRemapCampaignPortalsModal', showModal } = props
  const { bulkPortalRemap } = callbacks

  const modalPayload = useBulkRemapCampaignPortalsModal({ callbacks })

  const {
    callbacks: {
      setState,
    },
    bulkRemapPayload,
    fileData,
    updating,
  } = modalPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Remap" titleSecondLine="Campaign Portals" />

      <SidebarModal.Content>
        <Box flexDirection="column">
          <Form.Field direction="column" label="File">
            <FileInput
              input={{ onChange: (data: string) => setState({ fileData: data }) }}
            />
          </Form.Field>
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!fileData}
          loading={updating}
          // @ts-expect-error TS2345
          onClick={() => bulkPortalRemap(bulkRemapPayload)}
          size="large"
        >
          {!fileData ? 'Upload File' : 'Remap Portals'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <BulkRemapCampaignPortalsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
